import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerTrigger } from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";

const MobileNav = () => {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);

  if (!isMobile) {
    return null;
  }

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Open navigation">
          <Menu className="h-5 w-5" />
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>Menu</DrawerTitle>
        </DrawerHeader>
        <div className="grid gap-2 p-4 pb-8 text-center">
          <Link to="/learn" onClick={() => setOpen(false)} className="font-medium">Learn</Link>
          <Link to="/coaching" onClick={() => setOpen(false)} className="font-medium">Coaching</Link>
          <Link to="/about" onClick={() => setOpen(false)} className="font-medium">About</Link>
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default MobileNav;
